import type {ScheduleDTO} from '../../../features/recruitment/components/Container/Presenter/Schedule';
import type {
  RecruitmentDetailSchedule,
  RecruitmentSchedule,
} from '../../entities/recruitment/schema';

export const formatScheduleDataByRecruitDetail = (
  schedules: RecruitmentDetailSchedule,
): ScheduleDTO => {
  return {
    id: schedules.id,
    name: schedules.name,
    entryStart: schedules.entryStart,
    entryEnd: schedules.entryEnd,
    isEntryEndAllDay: schedules.isEntryEndAllDay,
    eventStart: schedules.eventStart,
    isEventStartAllDay: schedules.isEventStartAllDay,
    eventEnd: schedules.eventEnd,
    isEventEndAllDay: schedules.isEventEndAllDay,
    place: schedules.place,
    isRegistered: schedules.hasAddCalendar,
    registeredCount: schedules.addCalendarUsers,
  };
};

export const formatScheduleDataByRecruitList = (
  schedules: RecruitmentSchedule,
): ScheduleDTO => {
  return {
    id: schedules.id,
    name: schedules.name,
    entryStart: schedules.entryStart,
    entryEnd: schedules.entryEnd,
    isEntryEndAllDay: schedules.isEntryEndAllDay,
    eventStart: schedules.eventStart,
    isEventStartAllDay: schedules.isEventStartAllDay,
    eventEnd: schedules.eventEnd,
    isEventEndAllDay: schedules.isEventEndAllDay,
    place: schedules.place,
    isRegistered: schedules.isCalendarRegistered,
    registeredCount: schedules.calendarRegisteredCount,
  };
};
